import { Box, Typography, useI18n } from '@ops-matrix/design-system-ui';
import { useEffect } from 'react';
import { useConsumerAuth } from '../contexts/ConsumerAuthContext';

export default function LogoutPage() {
  const { logout } = useConsumerAuth();
  const { t } = useI18n();

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Typography>{t('auth.signingOut')}</Typography>
    </Box>
  );
}
